import { render, staticRenderFns } from "./Real-timeinfo.vue?vue&type=template&id=dc3b2520&"
import script from "./Real-timeinfo.vue?vue&type=script&lang=js&"
export * from "./Real-timeinfo.vue?vue&type=script&lang=js&"
import style0 from "./Real-timeinfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports